import { Box, Card, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import ReactMarkdown from 'react-markdown';

const MessageBoxChat = ({ output }) => {
  const textColor = useColorModeValue('#1B2559', 'white');
  return (
    <Box
      display={output ? 'flex' : 'none'}
      px="22px !important"
      pl="22px !important"
      color={textColor}
      // minH="450px"
      fontSize={{ base: 'sm', md: 'md' }}
      lineHeight={{ base: '24px', md: '26px' }}
      fontWeight="500"
      boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
      width="100%"
      p="20px"
      flexDirection="column"
      position="relative"
      borderRadius="14px"
      minWidth="0px"
      wordwrap="break-word"
      backgroundClip="border-box"
    >
      <ReactMarkdown className="font-medium">
        {output ? output : ''}
      </ReactMarkdown>
    </Box>
  );
};

export default MessageBoxChat;
